import { Typography } from '@mui/material'
import React from 'react'
import CustomBox from '../CommonComp/CustomBox/CustomBox'
import AllUserList from './AllUserList';
import BuyerUserList from './BuyerUserList';
import TemporaryUserList from './TemporaryUserList';
import UserListByVoucher from './UserListByVoucher';

function UserTabBody({activeTab}) {
  return (
    <CustomBox padding={0} sx={{minHeight: 200, display: "flex", justifyContent: "center", alignItems: "center"}}>
       {activeTab == 1 && <AllUserList />}
       {activeTab == 2 && <BuyerUserList />}
       {activeTab == 3 && <TemporaryUserList />}
       {activeTab == 4 && <UserListByVoucher />}
    </CustomBox>
  )
}

export default UserTabBody